import { ReactNode, useRef } from 'react';
import { ScrollView } from 'react-native';
import { CardBlockScrollContext } from './context';

interface Props {
  children: ReactNode;
}

export function CardBlockScrollProvider({ children }: Props) {
  const scrollView = useRef<ScrollView>(null);
  return (
    <CardBlockScrollContext.Provider value={scrollView}>{children}</CardBlockScrollContext.Provider>
  );
}
